/* eslint-disable
    default-case
*/
import {EventConstants, FluxAction} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';

export interface BenchlingSelection {
  cid: string;
  start: number;
  end: number;
}

export interface KeyData {
  key: string;
  data: {selection: BenchlingSelection};
}

// selection restore data could be keyed to specify which component it is meant for
export type SelectionRestoreData = BenchlingSelection | {key: string; data: {selection: BenchlingSelection}};

class SelectionStore extends Store {
  restoreData!: SelectionRestoreData | null;
  protocolID?: string;

  override resetState(): void {
    this.restoreData = null;
  }

  getState(): {restoreData: SelectionRestoreData | null} {
    return {restoreData: this.restoreData};
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.SELECTION_SET: {
        const {data} = action;
        this.restoreData = data;
        this.emitChange();
        break;
      }

      case EventConstants.EDITOR_REPLACE:
      case EventConstants.DOCUMENT_REVERT:
      case EventConstants.ENTRY_REVERT:
      case EventConstants.NOTE_REPLACE:
      case EventConstants.WORKFLOW_STAGE_ENTRY_REVERT:
      case EventConstants.TEMPLATE_REVERT:
      case EventConstants.SUBTEMPLATE_REVERT: {
        const {restoreData} = action;
        this.restoreData = restoreData;
        this.emitChange();
        break;
      }

      case EventConstants.EDITOR_OPEN_COMPLETED: {
        const {protocolID, protocol} = action;
        if (protocolID === this.protocolID) {
          this.restoreData =
            protocol.name.length === 0
              ? {
                  key: 'title',
                  data: {
                    selection: {
                      cid: 'titleeditor',
                      start: 0,
                      end: 0,
                    },
                  },
                }
              : null;
          this.emitChange();
        }
        break;
      }

      case EventConstants.EDITOR_CLOSE:
        this.resetState();
        this.emitChange();
        break;
    }

    return true;
  }
}

const selectionStore = new SelectionStore(AppDispatcher);
export default selectionStore;
